package org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_selection

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.encodeToJsonElement
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.delete_product_set.ProductSetModel
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.selection.ProductSetData
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_selection.UpdateProductSetListRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class UpdateProductSetListImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): UpdateProductSetListRepository {

    private var abortController = requestManager.createController()

    override suspend fun updateProductSetList(
        id: String,
        sets: List<ProductSetData>
    ): ProductSetModel {
        abortController = requestManager.createController()

        val query = """
           
          mutation setProductSets(${'$'}id: ID!,${'$'}fields: [SetInput]!) {
            cashAssist {
              setProductSets(id:${'$'}id, fields:${'$'}fields) {
                ${ApiUtils.Field.id}
                ${ApiUtils.Field.mod_ver}
                sets {
                  category {
                    ${ApiUtils.Field.id}
                    ${ApiUtils.Field.name}
                    ${ApiUtils.Field.__typename}
                  }
                  ${ApiUtils.Field.course}
                  ${ApiUtils.Field.minQuantity}
                  ${ApiUtils.Field.maxQuantity}
                  ${ApiUtils.Field.priceLevel}
                  ${ApiUtils.Field.isCollectPoints}
                  ${ApiUtils.Field.weekDays}
                  fixProducts {
                    ${ApiUtils.Field.code}
                    ${ApiUtils.Field.amount}
                    ${ApiUtils.Field.price}
                    ${ApiUtils.Field.__typename}
                  }
                  ${ApiUtils.Field.__typename}
                }
                ${ApiUtils.Field.__typename}
              }
              ${ApiUtils.Field.__typename}
            }
          }


           
        """.trimIndent()

        val variables = buildJsonObject {
            put("id",id)
            put("fields", Json.encodeToJsonElement(sets))
        }

        val graphQLQuery = buildJsonObject {
            put("query", query)
            put("variables", variables)
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }



    }
}
